import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { InfoboothsEntity } from './infobooths.models'

@Injectable({
  providedIn: 'root',
})
export class InfoboothsApiService extends GbApiService {
  getInfobooths(urlName: string): Observable<InfoboothsEntity[]> {
    const url = `auctions/${urlName}/infobooths/`
    return this.get<InfoboothsEntity[]>(url)
  }

  createInfobooth(infobooth: InfoboothsEntity): Observable<InfoboothsEntity> {
    const url = `auctions/${infobooth.auction}/infobooths/`
    return this.post<InfoboothsEntity>(url, infobooth)
  }

  updateInfobooth(infobooth: InfoboothsEntity): Observable<InfoboothsEntity> {
    const url = `auctions/${infobooth.auction}/infobooths/${infobooth.uuid}/`
    return this.patch<InfoboothsEntity>(url, infobooth)
  }

  deleteInfobooth(urlName: string, uuid: string): Observable<void> {
    const url = `auctions/${urlName}/infobooths/${uuid}/`
    return this.delete<void>(url)
  }
}
